import { transparentize, mode } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => ({
    content: {
        bg: mode('white', 'gray.550')(props),
        border: '1px solid',
        borderColor: mode('inherit', transparentize(`white`, 0.24)(props.theme))(props),
        borderRadius: 'base',
        boxShadow: 'md',
        _focus: {
            outline: 0,
            boxShadow: 'outline',
        },
    },
    header: {
        paddingX: 4,
        paddingY: 4,
        borderBottomWidth: '1px',
        bg: mode('white', 'gray.550')(props),
        borderTopRadius: 'base',
    },
    body: {
        paddingX: 4,
        paddingY: 4,
        fontSize: 'md',
        bg: mode('white', 'gray.550')(props),
        borderRadius: 'base',
    },
    footer: {
        paddingX: 4,
        paddingY: 4,
        borderTopWidth: '1px',
        bg: mode('white', 'gray.550')(props),
        borderBottomRadius: 'base',
    },
    arrow: {
        border: '1px solid',
        borderColor: mode('inherit', transparentize(`white`, 0.24)(props.theme))(props),
        boxShadow: 'none !important',
        zIndex: -1,
    },
    popper: {
        maxW: 'xs',
        zIndex: 101,
        ...props.popperProps,
    },
});
const getReverseStyle = (props) => {
    const baseStyle = getBaseStyle(props);
    return {
        ...baseStyle,
        header: {
            ...baseStyle.header,
            bg: mode('gray.550', 'white')(props),
            color: mode('white', 'gray.600')(props),
        },
        body: {
            ...baseStyle.body,
            bg: mode('gray.550', 'white')(props),
            color: mode('white', 'gray.600')(props),
        },
        footer: {
            ...baseStyle.footer,
            bg: mode('gray.550', 'white')(props),
            color: mode('white', 'gray.600')(props),
        },
        arrow: {
            ...baseStyle.arrow,
            bg: mode('gray.550', 'white')(props),
        },
    };
};
const getDarkStyle = (props) => {
    const baseDarkStyle = getBaseStyle({ ...props, colorMode: 'dark' });
    return {
        ...baseDarkStyle,
        header: {
            ...baseDarkStyle.header,
            color: 'white',
        },
        body: {
            ...baseDarkStyle.body,
            color: 'white',
        },
        footer: {
            ...baseDarkStyle.footer,
            color: 'white',
        },
        arrow: {
            ...baseDarkStyle.arrow,
            bg: 'gray.550',
        },
    };
};
const getLightStyle = (props) => {
    const baseLightStyle = getBaseStyle({ ...props, colorMode: 'light' });
    return {
        ...baseLightStyle,
        header: {
            ...baseLightStyle.header,
            color: 'gray.600',
        },
        body: {
            ...baseLightStyle.body,
            color: 'gray.600',
        },
        footer: {
            ...baseLightStyle.footer,
            color: 'gray.600',
        },
        arrow: {
            ...baseLightStyle.arrow,
            bg: 'white',
        },
    };
};
const parts = ['popper', 'content', 'header', 'body', 'footer', 'arrow'];
const variants = {
    base: getBaseStyle,
    reverse: getReverseStyle,
    dark: getDarkStyle,
    light: getLightStyle,
};
export default {
    parts,
    variants,
    baseStyle: getBaseStyle,
    defaultProps: {
        variant: 'base',
    },
};
//# sourceMappingURL=popover.js.map